import SelectC8 from './SelectC8';

export default class GravityForm {
  constructor(el) {
    this.$this = $(el);
    this.$form = this.$this.find('.gg-gravity-form');
    this.$header = $('header.header');
    this.$htmlBody = $('html, body');

    this.offsetSpace = 150;

    // Initialize global SelectC8 instance
    this.globalSelectC8 = new SelectC8();

    // Selectors for select-c8 functionality
    this.selectors = {
      selectC8: '.select-c8',
      dropdownSelectC8: '.dropdown-select-c8',
      selectContainer: '.gfield--type-select',
      formSelectC8: '.form-select-c8',
      dropdownToggle: '.dropdown-toggle',
      dropdownMenu: '.dropdown-menu-c8',
      dropdownListItem: 'li.optiton-select',
      filterOption: '.filter-option',
      errorField: '.gfield_error',
      validationMessage: '.validation_message',
      gfield: '.gfield',
      errorFields: '.gfield_error input, .gfield_error textarea, .gfield_error select',
      captchaField: '.gfield--type-captcha',
      recaptchaContainer: '.ginput_recaptcha',
      ginputContainer: '.ginput_container',
      gfieldChoiceInput: '.gfield-choice-input',
      gchoiceOtherControl: '.gchoice_other_control',
    };

    // Classes for select-c8 functionality
    this.classes = {
      selectC8: 'select-c8',
      selectDone: 'select-done',
      formSelectC8: 'form-select-c8',
      selected: 'selected',
      gfieldError: 'gfield_error',
      gfieldTypeEmail: 'gfield--type-email',
      gfieldTypeCaptcha: 'gfield--type-captcha',
      gfieldErrorSelector: 'gfield_error',
      formControl: 'form-control',
      labelAnimation: 'label-animation form-label',
    };

    // Input types for validation
    this.inputTypes = {
      email: 'email',
    };

    // Timing configurations
    this.timings = {
      formCheck: 100,
      selectC8Ready: 200,
      autoSelectDelay: 500,
      focusDelay: 350,
      scrollDelay: 50,
      scrollDuration: 700,
    };

    // Debug flag for console logs (set to false in production)
    this.debugMode = false;
  }

  init() {
    this.bindGravityFormsEvents();
    this.waitForGravityForm();
    this.bindSelectC8TriggerChange();
    this.bindSaveLinkEvent();
    this.bindOtherChoiceFocus();
    this.bindFakeSubmitButton();
  }

  bindGravityFormsEvents() {
    $(document).on('gform_pre_submission', (_event, formId) => {
      this.handlePreSubmission(formId);
    });

    $(document).on('gform_post_render', (_event, formId) => {
      this.handlePostRender(formId);
    });
  }

  handlePreSubmission(formId) {
    const $form = this.getFormElement(formId);
    if (this.isInGravityForm($form)) {
      // Pre-submission logic can be added here if needed
    }
  }

  handlePostRender(formId) {
    const $form = this.getFormElement(formId);

    if (!this.isInGravityForm($form)) {
      return;
    }

    // Re-enable fake submit button after GF re-renders (e.g. validation fail)
    $form.closest('.gg-gravity-form').find('.gform-btn--submit').removeClass('disabled');

    setTimeout(() => {
      this.reinitializeFormComponents();
    }, 0);

    setTimeout(() => {
      this.focusFirstErrorField(formId);
    }, this.timings.formCheck);
  }

  checkInputActiveFocus() {
    const activeFocus = 'active-focus';
    const formControlSelector = 'input[type="text"], input[type="email"], input[type="tel"], input[type="number"], textarea';

    this.$this.find(formControlSelector).each((_i, el) => {
      const $el = $(el);
      const $gfield = $el.closest(this.selectors.gfield);
      if (!$gfield.length) {
        return;
      }
      const value = $el.val();
      if (value && value.length > 0) {
        $gfield.addClass(activeFocus);
      } else {
        $gfield.removeClass(activeFocus);
      }
    });
  }

  reinitializeFormComponents() {
    this.initSelectC8();
    this.initLabelAnimations();
    this.handleValidationClear();
    this.handleSubmitValidation();
    this.bindOtherChoiceFocus();
  }

  waitForGravityForm() {
    if (this.$this.find('.gform_wrapper').length > 0) {
      this.initSelectC8();
      this.initLabelAnimations();
      this.bindSubmitEvent();
      this.handleSubmitValidation();
    } else {
      setTimeout(() => {
        this.waitForGravityForm();
      }, this.timings.formCheck);
    }
  }

  scrollOnTopSection(el, customTopHeight = 150) {
    if (el && el.length) {
      const offsetEl = el.offset();
      let headerHeight = 0;
      let hieghtFilterTab = 0;
      if (this.$header.length) {
        headerHeight = this.$header.outerHeight();
      }
      if ($('.gg-filter-tabs').length) {
        hieghtFilterTab = $('.gg-filter-tabs').outerHeight() + 150;
      }
      $('html, body').animate(
        {
          scrollTop: offsetEl.top - headerHeight - hieghtFilterTab + customTopHeight,
        },
        this.timings.scrollDuration,
      );
    }
  }

  focusFirstErrorField(formId) {
    const $form = this.getFormElement(formId);

    if (!$form.length || !$form.find(`.${this.classes.gfieldErrorSelector}`).length) {
      return;
    }

    const $firstErrorField = $form.find(`.${this.classes.gfieldErrorSelector}`).first();
    const $firstErrorFieldInput = $firstErrorField.find('input, textarea, select').first();

    // Always scroll to error field to ensure it's properly positioned below header
    this.scrollOnTopSection($firstErrorField, -this.offsetSpace);

    // Focus after scroll animation starts
    if ($firstErrorFieldInput.length) {
      setTimeout(() => $firstErrorFieldInput.focus(), this.timings.focusDelay);
    }
  }

  isElementInViewport($element) {
    if (!$element || !$element.length) {
      return false;
    }

    const elementTop = $element.offset().top;
    const elementBottom = elementTop + $element.outerHeight();
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    // Account for header height
    let headerHeight = 0;
    if (this.$header.length) {
      headerHeight = this.$header.outerHeight();
    }

    // Element is in viewport if it's between viewport top (+ header) and bottom
    return elementBottom > (viewportTop + headerHeight) && elementTop < viewportBottom;
  }

  hagtagHandle() {
    const currentURL = window.location.origin + window.location.pathname;
    const hagtag = '#thank-you';
    const urlSlug = currentURL + hagtag;
    window.history.replaceState(null, null, urlSlug);
  }

  saveLaterHashHandle() {
    const currentURL = window.location.origin + window.location.pathname;
    const hashtag = '#save-later';
    const urlSlug = currentURL + hashtag;
    window.history.replaceState(null, null, urlSlug);
  }

  bindSaveLinkEvent() {
    $(document).on('click', '.gform_save_link', (e) => {
      const $saveLink = $(e.currentTarget);
      const $form = $saveLink.closest('form');

      if (!this.isInGravityForm($form)) {
        return;
      }

      this.saveLaterHashHandle();
    });
  }

  bindSubmitEvent() {
    // Use namespaced event to prevent duplicate bindings
    const eventNamespace = `.gformSubmit${Date.now()}`;

    // Store namespace for potential cleanup
    this.submitEventNamespace = eventNamespace;

    // Bind with namespace
    $(document).on(`gform_confirmation_loaded${eventNamespace}`, (_event, formId) => {
      // After confirmation loads, GF replaces form with #gforms_confirmation_message_${formId}
      const $confirmation = $(`#gform_confirmation_message_${formId}`);
      // Check if confirmation belongs to THIS instance
      const belongsToThisInstance = this.$this.find(`#gform_confirmation_message_${formId}`).length > 0;

      if (!belongsToThisInstance) {
        return;
      }

      // Scroll to the top of the confirmation message itself (kept in view via offset).
      if ($confirmation.length) {
        this.scrollOnTopSection($confirmation, -this.offsetSpace);
        this.hagtagHandle();

        // Push GTM dataLayer event only for forms inside .gg-application-form
        const isInApplicationForm = $confirmation.closest('.gg-application-form').length > 0;
        if (isInApplicationForm) {
          this.pushFormSubmitSuccessEvent(formId, $confirmation);
        }
      }
    });
  }

  pushFormSubmitSuccessEvent(formId, $form) {
    // Get form name from title or aria-label attribute
    const formName = this.getFormName($form, formId);

    // Generate unique submission ID
    const submissionId = this.generateSubmissionId();

    // Push to dataLayer
    window.dataLayer = window.dataLayer || [];
    /* eslint-disable camelcase */
    window.dataLayer.push({
      event: 'gform_submit_success',
      form_id: formId,
      form_name: formName,
      submission_id: submissionId,
      source_page_url: window.location.href,
    });
    /* eslint-enable camelcase */
  }

  getFormName($form, formId) {
    // Return form ID as form name
    return `Form ${formId}`;
  }

  generateSubmissionId() {
    // Generate unique submission ID using timestamp + random string
    const timestamp = Date.now();
    const random = Math.random().toString(36).substring(2, 9);
    return `${timestamp}-${random}`;
  }

  handleSubmitValidation() {
    // Bind submit validation to submit buttons to catch before Gravity Forms processes
    this.$this.find('.gform_wrapper form').each((_i, form) => {
      const $form = $(form);
      const $submitButtons = $form.find('input[type="submit"], button[type="submit"], input[type="button"]');

      // Remove existing click validation listener
      $submitButtons.off('click.validation');

      // Add click validation listener on submit buttons
      $submitButtons.on('click.validation', (_e) => {
        // Pre-submit actions can be added here if needed
      });
    });
  }

  handleValidationClear() {
    const errorFields = this.$this.find(this.selectors.errorFields);

    errorFields.each((_i, field) => {
      const $field = $(field);
      const $gfield = $field.closest(this.selectors.gfield);
      const validationText = $gfield.find(this.selectors.validationMessage).text().toLowerCase();
      const isRequiredError = validationText.includes('required');

      $field.off('input.validation change.validation blur.validation');

      const validateAndClear = () => {
        const fieldValue = $field.val();
        const isValid = this.validateField($field, fieldValue, isRequiredError);

        if (isValid) {
          this.clearFieldError($gfield, $field);
        }
      };

      $field.on('input.validation change.validation blur.validation', validateAndClear);
    });
  }

  validateField($field, value, isRequiredError) {
    const trimmedValue = value ? value.trim() : '';

    if (isRequiredError) {
      return trimmedValue !== '';
    }

    if (!trimmedValue) {
      return false;
    }

    const $gfield = $field.closest(this.selectors.gfield);
    const fieldType = $field.attr('type');
    const isEmailField = fieldType === this.inputTypes.email ||
      $gfield.hasClass(this.classes.gfieldTypeEmail);

    if (isEmailField) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedValue);
    }

    return true;
  }

  clearFieldError($gfield, $field) {
    $gfield.removeClass(this.classes.gfieldError);
    $gfield.find(this.selectors.validationMessage).remove();
    $field.removeClass(this.classes.gfieldError);
    $field.attr('aria-invalid', 'false');
    $field.removeAttr('aria-describedby');
  }

  initSelectC8() {
    this.processSelectContainers();
    this.setupGlobalSelectC8Instance();
    this.syncAllSelectC8WithCurrentValues();
  }

  processSelectContainers() {
    this.$this.find(this.selectors.selectContainer).each((_i, container) => {
      this.processSelectContainer($(container));
    });
  }

  processSelectContainer($container) {
    const $select = $container.find('select');

    if (!$select.length) {
      return;
    }

    if (this.shouldSkipRepeaterItemReinit($container, $select)) {
      return;
    }

    this.cleanupSelectC8Elements($container, $select);
    this.addSelectC8Classes($container, $select);
  }

  shouldSkipRepeaterItemReinit($container, $select) {
    // Simplified: just check if dropdown already exists
    const hasExistingDropdown = $container.find(this.selectors.dropdownSelectC8).length > 0;

    if (hasExistingDropdown) {
      this.syncSelectC8WithCurrentValue($select);
      return true;
    }

    return false;
  }

  cleanupSelectC8Elements($container, $select) {
    $container.find(this.selectors.dropdownSelectC8).remove();
    $select.removeClass(`${this.classes.selectC8} ${this.classes.selectDone}`);
    $container.removeClass(this.classes.formSelectC8);
  }

  addSelectC8Classes($container, $select) {
    $select.addClass(this.classes.selectC8);
    $container.addClass(this.classes.formSelectC8);
  }

  setupGlobalSelectC8Instance() {
    this.globalSelectC8.$callSelectC8 = $(this.selectors.selectC8);

    const needsInit = this.checkIfSelectC8NeedsInit();

    if (needsInit) {
      this.globalSelectC8.init();
    } else {
      this.globalSelectC8.renderSelectToDropdown();
    }
  }

  checkIfSelectC8NeedsInit() {
    return $(this.selectors.selectC8).length > 0 &&
      $(this.selectors.dropdownSelectC8).length === 0;
  }

  initLabelAnimations() {
    // Add label-animation class to labels
    this.$this.find('.gfield label.gfield_label').each((_i, element) => {
      const $label = $(element);

      // Skip if already has label-animation class
      if ($label.hasClass(this.classes.labelAnimation)) {
        return;
      }

      // Add label-animation class
      $label.addClass(this.classes.labelAnimation);
    });
  }

  bindSelectC8TriggerChange() {
    this.$this.on('click.selectC8Trigger', this.selectors.dropdownListItem, (e) => {
      this.handleSelectC8ItemClick($(e.currentTarget));
    });
  }

  handleSelectC8ItemClick($li) {
    if ($li.hasClass('disabled')) {
      return;
    }

    const $select = $li.closest(this.selectors.formSelectC8).find('select');
    if (!$select.length) {
      return;
    }

    const index = $li.index();
    const $options = $select.find('option');
    const val = $options.eq(index).val();

    this.updateSelectValue($select, val, true); // Pass flag to prevent loop
  }

  updateSelectValue($select, value, skipSync = false) {
    if (skipSync) {
      $select.data('skip-sync', true);
    }

    $select.val(value);
    $select.trigger('change');

    if (skipSync) {
      setTimeout(() => {
        $select.removeData('skip-sync');
      }, 0);
    }
  }



  syncSelectC8WithCurrentValue($select) {
    if ($select.data('skip-sync')) {
      return;
    }

    const currentValue = $select.val();
    const $container = $select.closest(this.selectors.selectContainer);
    const $dropdown = $container.find(this.selectors.dropdownSelectC8);

    if (!$dropdown.length || !currentValue) {
      return;
    }

    const $selectedOption = $select.find(`option[value="${currentValue}"]`);

    if (!$selectedOption.length) {
      return;
    }

    this.updateDropdownText($dropdown, $selectedOption);
    this.updateDropdownSelectedState($dropdown, $selectedOption);
  }

  updateDropdownText($dropdown, $selectedOption) {
    const selectedText = $selectedOption.text();
    $dropdown.find(this.selectors.filterOption).text(selectedText);
  }

  updateDropdownSelectedState($dropdown, $selectedOption) {
    const selectedIndex = $selectedOption.index();
    $dropdown.find(this.selectors.dropdownListItem)
      .removeClass(this.classes.selected)
      .eq(selectedIndex)
      .addClass(this.classes.selected);
  }

  syncAllSelectC8WithCurrentValues() {
    // Sync all SelectC8 dropdowns with their current select values
    this.$this.find(`${this.selectors.selectContainer} select`).each((_i, select) => {
      this.syncSelectC8WithCurrentValue($(select));
    });
  }

  getFormElement(formId) {
    return $(`#gform_${formId}`);
  }

  isInGravityForm($element) {
    return $element.closest('.gg-gravity-form').length > 0;
  }

  bindOtherChoiceFocus() {
    // Remove existing event handlers to prevent duplicates
    this.$this.off('change.otherChoice', this.selectors.gfieldChoiceInput);
    this.$this.off('click.otherControl', this.selectors.gchoiceOtherControl);

    // Bind change event to all choice inputs (radio/checkbox)
    this.$this.on('change.otherChoice', this.selectors.gfieldChoiceInput, (e) => {
      const $input = $(e.currentTarget);

      // Only proceed if the input is checked
      if (!$input.is(':checked')) {
        return;
      }

      // Find the parent gfield to restore previous "Other" controls
      const $gfield = $input.closest('.gfield');

      // Find all "Other" controls in this field and restore their value if empty
      $gfield.find(this.selectors.gchoiceOtherControl).each((_i, otherControl) => {
        const $otherControl = $(otherControl);
        const $parentChoice = $otherControl.closest('.gchoice');
        const $parentInput = $parentChoice.find(this.selectors.gfieldChoiceInput);

        // If this other control's parent input is not checked and value is empty, restore "Other"
        if (!$parentInput.is(':checked') && $otherControl.val().trim() === '') {
          $otherControl.val('Other');
        }
      });

      // Find the "Other" input control near this choice input
      const $otherControl = $input.closest('.gchoice').find(this.selectors.gchoiceOtherControl);

      // If "Other" control exists, focus on it and clear value
      if ($otherControl.length > 0) {
        setTimeout(() => {
          $otherControl.focus();
          $otherControl.val('');
        }, 100);
      }
    });

    // Bind click event directly to "Other" control inputs
    this.$this.on('click.otherControl', this.selectors.gchoiceOtherControl, (e) => {
      const $otherControl = $(e.currentTarget);

      // Focus on the input
      $otherControl.focus();

      // Clear the value
      $otherControl.val('');

      // Ensure the parent radio/checkbox is checked
      const $parentChoice = $otherControl.closest('.gchoice');
      const $parentInput = $parentChoice.find(this.selectors.gfieldChoiceInput);

      if ($parentInput.length > 0 && !$parentInput.is(':checked')) {
        $parentInput.prop('checked', true).trigger('change');
      }
    });
  }

  bindFakeSubmitButton() {
    // Bind fake submit button to trigger real form submission
    this.$this.on('click', '.gform-btn--submit', (e) => {
      e.preventDefault();

      const $fakeButton = $(e.currentTarget);

      if ($fakeButton.hasClass('disabled')) {
        return;
      }

      const $form = $fakeButton.closest('.gg-gravity-form').find('.gform_wrapper form');

      if (!$form.length) {
        return;
      }

      $fakeButton.addClass('disabled');

      const $realSubmitButton = $form.find('input[type="submit"], button[type="submit"], .gform_button').first();

      if (!$realSubmitButton.length) {
        return;
      }

      // Use GF's own submission handler if available (required by GF)
      if (window.gform && window.gform.submission && window.gform.submission.handleButtonClick) {
        window.gform.submission.handleButtonClick($realSubmitButton[0]);
      } else {
        // Fallback: execute the onclick attribute directly
        const onclickAttr = $realSubmitButton.attr('onclick');
        if (onclickAttr) {
          // eslint-disable-next-line no-new-func
          new Function(onclickAttr).call($realSubmitButton[0]);
        } else {
          $form.trigger('submit', [true]);
        }
      }
    });
  }

}

$('.gg-gravity-form').each((_index, el) => {
  const instance = new GravityForm(el);
  instance.init();
});
